import React, { createElement, useEffect, useState } from 'react';
import { Form, Button, ConfigProvider, message, Spin, Col, Row, Switch, Space } from 'antd';
import { insertDynamicTableData, updateDynamicTableData, getDynamicTableDataDetail, } from '../../../api/form';
import { Base64 } from 'js-base64';
import zhCN from 'antd/lib/locale/zh_CN';
import 'moment/locale/zh-cn';
import ErrorBoundary from '../../common/errorBoundary';
import ErrorComponent from '../../common/errorComponent';
const myZh = {
    ...zhCN,
    DatePicker: {
        ...zhCN.DatePicker,
        lang: {
            ...zhCN.DatePicker.lang,
            monthFormat: 'M月',
            shortWeekDays: ['日', '一', '二', '三', '四', '五', '六'],
        },
    },
};
const formItemLayout = {};
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const edit = urlParams.get('edit');
const formId = Number(Base64.decode(urlParams.get('form')).replace('abc567', ''));
const lineId = Number(urlParams.get('lineId'));
const pLineId = Number(urlParams.get('pLineId'));
const tk = urlParams.get('tk');
const iForm = (props, ref) => {
    const { children, column = 1 } = props;
    const [error, setError] = useState(false);
    const [errmsg, setErrmsg] = useState(null);
    const [checked, setChecked] = useState(false);
    const [links, setLinks] = useState([]);
    const [vsctrl, setVsctrl] = useState([]);
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();
    useEffect(() => {
        setError(false);
        try {
            const tmep = [];
            (children || []).forEach((e) => {
                const options = e?.props?.options?.options || [];
                let flag = false;
                for (let i = 0; i < options.length; i++) {
                    if (options[i]?.link?.length && e?.props?.options?.type === '自定义') {
                        flag = true;
                        break;
                    }
                }
                const { componentId } = e.props;
                if (options.length && flag && !componentId) {
                    tmep.push({
                        componentId: e.key,
                        options,
                    });
                }
            });
            setLinks(tmep);
            if (edit === '1' || tk) {
                const tt = [];
                tmep.forEach(({ componentId, options }) => {
                    tt.push({
                        current: [],
                        links: options,
                    });
                });
                setVsctrl(tt);
            }
            if (lineId) {
                const params = {
                    reportId: Number(formId),
                    dataId: Number(lineId),
                    flag: 1
                };
                setLoading(true);
                getDynamicTableDataDetail(params).then((res) => {
                    Object.entries(res.data).forEach((e) => {
                        form.setFieldValue(e[0], e[1]);
                    });
                    setLoading(false);
                    const tt = [];
                    tmep.forEach(({ componentId, options }) => {
                        let value = res.data[componentId];
                        let current;
                        if (Array.isArray(value)) {
                            current = (value || [])?.reduce((pre, next) => {
                                return [...pre, ...(options.find((e) => e.value === next)?.link || [])];
                            }, []);
                        }
                        else {
                            current = [options.find((e) => e.value === value)?.link || []];
                        }
                        tt.push({
                            current,
                            links: options,
                        });
                    });
                    setVsctrl(tt);
                });
            }
        }
        catch (error) {
            console.log(error);
            setError(true);
            setErrmsg('表单初始化异常,请检查配置项或更新组件');
        }
    }, []);
    const submit = (value, type = 'continue') => {
        try {
            form.validateFields().then((res) => {
                const reportId = formId;
                const data = {};
                Object.entries(value).forEach(([key, value]) => {
                    if (value?.fileList) {
                        data[key] = value?.fileList.map(({ name, uid, response }) => ({ name, uid, status: response.code === 200 ? 'done' : 'error', url: response.data.url }));
                    }
                    else {
                        data[key] = value;
                    }
                });
                if (reportId) {
                    const params = {
                        reportId,
                        data,
                    };
                    if (pLineId) {
                        params.data.pid = pLineId;
                    }
                    if (lineId && edit === '2') {
                        params.data.id = lineId;
                        updateDynamicTableData(params).then((res) => {
                            if (res.code === 200) {
                                message.success('修改成功!');
                                window.parent.postMessage(type, '*');
                            }
                        });
                    }
                    else if (edit === '1') {
                        insertDynamicTableData(params).then((res) => {
                            if (res.code === 200) {
                                message.success('添加成功!');
                                window.parent.postMessage(type, '*');
                            }
                        });
                    }
                    if (!checked) {
                        form.resetFields();
                    }
                }
                else {
                    message.error('报表id丢失!');
                }
            });
        }
        catch (error) {
            console.log(error);
            setError(true);
            setErrmsg('表单提交异常,请重新配置字段或更新组件');
        }
    };
    const submitAndClose = () => {
        try {
            const value = form.getFieldsValue();
            submit(value, 'close');
        }
        catch (error) {
            console.log(error);
            setError(true);
            setErrmsg('表单提交异常,请重新配置字段或更新组件');
        }
    };
    const valueChange = (changedValues, allValues) => {
        try {
            const temp = [];
            links.forEach(({ componentId, options }) => {
                let value = allValues[componentId];
                let current;
                if (Array.isArray(value)) {
                    current = (value || [])?.reduce((pre, next) => {
                        return [...pre, ...(options.find((e) => e.value === next)?.link || [])];
                    }, []);
                }
                else {
                    current = [options.find((e) => e.value === value)?.link || []];
                }
                temp.push({
                    current,
                    links: options,
                });
            });
            setVsctrl(temp);
        }
        catch (error) {
            console.log(error);
            setError(true);
            setErrmsg('关联关系监听异常,请检查关联配置是否合法');
        }
    };
    return (createElement(ErrorBoundary, null, error ? (createElement(ErrorComponent, { ref: ref, errmsg: errmsg })) : (createElement("div", { ref: ref, style: { minHeight: '300px', padding: '10px' } },
        createElement(ConfigProvider, { locale: myZh },
            createElement(Spin, { spinning: loading },
                createElement(Form, Object.assign({ form: form }, props, formItemLayout, { onValuesChange: valueChange, onFinish: submit, className: "base_bg" }),
                    createElement(Row, { gutter: 16 }, React.Children.map((children || []).filter((e) => {
                        try {
                            if (!vsctrl.length)
                                return true;
                            const { key } = e;
                            let falg = true;
                            for (let i = 0; i < vsctrl.length; i++) {
                                const { current, links } = vsctrl[i];
                                for (let j = 0; j < links.length; j++) {
                                    const { link } = links[j];
                                    if (link.includes(key)) {
                                        falg = false;
                                        if (current.find((e) => e.includes(key))) {
                                            return true;
                                        }
                                    }
                                }
                            }
                            return falg;
                        }
                        catch (error) {
                            console.log(error);
                            setError(true);
                            setErrmsg('关联关系处理异常,请检查关联配置是否合法');
                            return true;
                        }
                    }), (child) => {
                        return React.cloneElement(child, { form, span: 24 / column });
                    })),
                    edit !== '3' && edit ? (createElement("div", { style: { display: 'flex', justifyContent: 'flex-start' } },
                        createElement(Row, { style: { marginTop: '10px' } },
                            createElement(Col, { span: 24 },
                                createElement(Space, { size: "middle" },
                                    "\u4FDD\u5B58\u672C\u6B21\u63D0\u4EA4\u5185\u5BB9:",
                                    createElement(Switch, { checked: checked, onChange: setChecked }))),
                            createElement(Col, { span: 24 },
                                createElement("div", { style: {
                                        display: 'flex',
                                        justifyContent: 'flex-start',
                                        gap: '50px',
                                        marginTop: '10px',
                                    } },
                                    createElement(Button, { htmlType: "reset" }, "\u91CD\u7F6E"),
                                    createElement(Button, { type: "primary", onClick: submitAndClose }, "\u63D0\u4EA4"),
                                    createElement(Button, { type: "primary", htmlType: "submit" }, "\u63D0\u4EA4\u5E76\u7EE7\u7EED")))))) : null)))))));
};
export default React.forwardRef(iForm);
